import { render, staticRenderFns } from "./MultiTableSource.vue?vue&type=template&id=74061a4a&scoped=true&"
import script from "./MultiTableSource.vue?vue&type=script&lang=js&"
export * from "./MultiTableSource.vue?vue&type=script&lang=js&"
import style0 from "./MultiTableSource.vue?vue&type=style&index=0&id=74061a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74061a4a",
  null
  
)

export default component.exports